export const indexToStep = (index: number): number => index + 1